// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { InputStyle } from "@flip/MobiusOverrides/TextField";
import { PlaceholderSelector } from "@flip/XDL/PreStyle/formField";
import { addressDrawerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/Header/AddressDrawerSelectCustomerContainer";
import { css } from "styled-components";

// XNG-Changes: FLIP-971
addressDrawerSelectCustomerContainerStyles.billToSelector = {
    billToSelectorDynamicDropdown: {
        cssOverrides: {
            formInputWrapper: css`
                && input {
                    ${PlaceholderSelector} {
                        font-style: italic;
                    }
                }
            `,
        },
    },
};

// XNG-Changes: FLIP-971
addressDrawerSelectCustomerContainerStyles.shipToSelector = {
    shipToSelectorDynamicDropdown: {
        cssOverrides: {
            formInputWrapper: css`
                && input {
                    ${PlaceholderSelector} {
                        font-style: italic;
                    }
                }
            `,
        },
    },
};
